module.exports = {
    hello_world: "Hello World!",
    search_enter: "Search",
    no: "No",
    yes: "Yes",
    alert: "Alert",
    next: "Next",
    retry: "Retry",
    error: "Error",
    previous: "Previous",
    first: "First",
    last: "Last",
    remember_me: "Remember Me",
    email: "Email Address",
    please_enter_email: "Please enter valid email",
    password: "Password",
    please_enter_valid_password: "Password should contain minimum 8 characters, minimum 1 capital letter, small letters and numeric",
    please_enter_password: "Please enter password",
    forgot_password: "Forgot Password",
    sign_up: "Sign Up",
    sign_in: "Sign In",
    dont_have_an_account: "Do not have an account ?",
    submit: "Submit",
    back_to: "Back to",
    login: "Login",
    logout: "Logout",
    change_password: "Change Password",
    my_profile: "My Profile",
    already_have_an_account: "Already have an account?",
    cancel: "Cancel",
    save: "Save",
    confirm_password: "Confirm Password",
    account: "Account",
    profile: "Profile",
    please_enter_confirm_password: "Confirm password same as password",
    please_enter_repeat_password: "Repeat password same as new password",
    contact: "Contact Number",
    please_enter_valid_contact: "Please enter valid contact number",
    resend: "Resend OTP",
    back: "Back",
    please_enter_name: "Please enter name",
    name: "Name",
    first_name: "First Name",
    please_enter_first_name: "Please enter first name",
    last_name: "Last Name",
    please_enter_last_name: "Please enter last name",
    please_select_type: "Please select type",
    please_enter_contact: "Please enter contact",
    url: "Url",
    title: "Title",
    please_enter_title: "Please enter title",
    update: "Update",
    status: "Status",
    select_status: "Select status",
    active: "Active",
    inactive: "Inactive",
    description: "Description",
    sr_no: "Sr. No.",
    action: "Action",
    edit: "Edit",
    delete: "Delete",
    view: "View",
    view_more: "View More",
    add_admin: "Add Admin",
    ok: "Ok",
    icon: "Icon",
    upload: "Upload",
    crop_icon: "Crop Icon",
    crop: "Crop",
    admin: "Admin",
    invalid_token: "Invalid Token",
    your_password_has_been_uccessfully_set: "Your password has been successfully set.",
    text: "Text",
    date_time: "Date & Time",
    enter_contact: "Enter contact Number",
    admin_user: "Admin User",
    image: "Image",
    roles: "Roles",
    current_password: "Current Password",
    new_password: "New Password",
    please_enter_current_password: "Please enter current password",
    manage_leads_and_deals: "Leads And Deals",
    add_deals: "Add Deals",
    edit_deals: "Edit Deals",
    add_deals: " Add Deals",
    add_leads: "Add Leads",
    mobile_number: "Phone Number",
    message: "Notes /Message",
    email: "Email",
    alt_mobile_number: "Alternate Phone Number",
    alt_email: "Alternate Email",
    fax: "Fax",
    address: "Address",
    alt_address: "Alternate Address",
    city: "City",
    state: "State",
    country: "Country",
    postal_code: "Zip/Postal Code",
    referred_by: "Referred By",
    company_name: "Company Name",
    rate: "Rate",
    margin: "Margin",
    country_rate: "Country Rate",
    setup_fee: "Setup Fee",
    notes: "Notes",
    please_enter_valid_setup_fee: "Please enter valid setup fee",
    please_enter_valid_country_rate: "Please enter valid county rate",
    please_enter_margin: "Please enter margin",
    please_enter_valid_rate: "Please enter valid rate",
    please_enter_valid_country: "Please enter country name",
    please_enter_state: "Please enter state",
    please_enter_valid_city: "Please enter city",
    please_enter_address: "Please enter Office/Building",
    please_enter_valid_country: "Please select country.",
    please_enter_state: "Please enter state.",
    please_enter_valid_city: "Please enter city.",

    please_enter_valid_email: "Please enter valid email",
    contract: "Add This As New Contractor",
    hide: " Hide This Lead",
    end_client: "End Client",
    add_clients: "Add Client",
    export_to_excel: "Export To Excel",
    add_client: "Add Client",
    edit_client: "Edit Client",
    back: "Back",
    end_client_name: "End Client Name",
    website: "Website",
    primary_contact_name: "Primary Contact Name",
    primary_contact_email: "Primary Contact E-mail",
    primary_contact_ext: "Primary Contact Extension",
    please_enter_valid_mobile_number: "Please enter  mobile number",
    please_enter_valid_postal_code: "Please enter postal code",
    dashboard: "Dashboard",
    setting: "",
    manage_currency: "Manage Currency",
    currency_exchange: "Currency Exchange",
    manage_website: "Manage Website",
    add_currency: "Add Currency",
    currency: "Currency",
    symbol: "Symbol",
    notification_value: "Legacy Notification Value ",
    monthly_exchange_rate: "Monthly Exchange Rate ",
    exchange_rate: "Legacy Exchange Rate ",
    vat_variable: "Vat Variable",
    margin_variable: "Margin Variable",
    total_variable: "Total Variable",
    conversion_lookup: "Conversion lookup",
    custom_name: "Custom Name",
    please_enter_currency: "please enter currency",
    please_enter_notification_value: "Please enter notification value",
    please_enter_valid_exchange_rate: "Please enter exchange rate",
    please_enter_monthly_exchange_rate: "Please enter monthly exchange rate",
    please_enter_valid_symbol: "Please enter symbol",
    add_website: "Add Website",
    site_name: "Site Name",
    site_email: "Site Email",
    username: "Site Username",
    password: "Site Password",
    url: "Site Url",
    notes: "Notes",
    please_enter_site_name: "Please enter website name",
    please_enter_valid_site_email: "Please enter valid email",
    please_enter_site_username: "please enter website username",
    please_enter_site_password: "please enter website password",
    please_enter_site_url: "please enter website url",
    no_record_found: "Sorry, There is no record found.",
    my_task_list: "My Task List",
    agency_client_name: "Agency/Client Name",
    assigned_task_list: "Assigned Task List",
    manage_agencies: "Manage Agency/Client",
    contractor_companies: "Contractor Companies",
    add_contractor_companies: " Add Contractor ",
    edit_contractor_companies: " Edit Contractors",
    add_manage_agencies: "Add Manage Agency/Client",
    edit_manage_agencies: "Edit Manage Agency/Client",
    monthly_invoices: "Manage Agency Invoices",
    other_payment: "Other Payments",
    payroll_partner: "Payroll Partners",
    add_payroll_partner: "Add Payroll Partner",
    edit_payroll_partner: "Edit Payroll Partner",
    manage_deposit: "Manage Deposit",
    add_manage_deposit: "Add Manage Deposit",
    add_manage_deposit: "Add Deposit",
    edit_manage_deposit: "Edit Deposit",
    please_enter_message: "Please Enter Notes",
    Please_enter_mobile_number: "Please enter valid mobile number",
    note_comments: "Notes/Comments",
    add_note: " Add Notes",
    head_1: "Sr.No",
    head_2: "Notes / Comments",
    head_3: "User",
    head_4: "Date",
    archive: "Archive",
    add_view_archive_data: "View Archive Data",
    manage_agency: "Manage Agency",
    manage_contract: "Manage Contracts",
    manage_users: "Manage Users",
    manage_contractors: "Manage Contractors",
    manage_payslip: "Manage Payslips",
    manage_role: "Manage Roles",
    manage_organization: "Manage Companies",
    manage_leads: "Manage Leads",
    manage_reports: "Manage Reports",
    phone_number: "Phone Number",
    alt_phone_number: "Alternate Phone Number",
    please_enter_phone_number: "Please enter phone number.",
    please_enter_org_name: "Please enter organization name.",
    contact_name: "Primary Contact Name",
    contact_names: "Contact Name",
    job_title: "Primary Contact Job Title ",
    job_contact_title: "Job Title ",
    contact_email: "Primary Contact E-mail",
    fax: "Fax",
    notes: "Notes",
    office: "Office#/Building",
    street: "Street",
    city: "City",
    state: "State/County",
    country: "Country",
    postal_code: "Post Code/Zip Code ",
    invoicing_contact_name: "Invoicing Contact Name",
    invoicing_phone_number: "Invoicing Contact Phone ",
    invoicing_email: "Invoicing Contact E-mail",
    invoicing_alt_email: "Alternate Invoicing E-mail",
    vat_number: "VAT Number",
    website: "Website",
    please_enter_contact_name: "Please enter contact name.",
    please_enter_job_title: "Please enter job title.",
    please_enter_notes: "Please enter notes.",
    please_enter_name: "Please enter name.",
    please_enter_agency_name: "Please enter agency/client name.",
    please_enter_other: "Please enter other detail.",
    please_enter_company_name: "Please enter company name.",
    please_enter_account_name: "Please enter account name.",
    please_enter_bank_city: "Please enter bank city.",
    please_enter_bank_name: "Please enter bank name.",
    please_enter_swift_code: "Please enter bank swift code name.",
    enter_invoice_notes: "Write your invoice notes here...",
    apartment: "Office/Building",
    skype_id: "Skype Id",
    other: "Other",
    contractor: "Contractor",
    monthly_invoice: "Manage Invoices",
    my_contract: "My Contracts",
    add_users: "Add User",
    add_roles: "Add Roles",
    edit_roles: "Edit Roles",
    activity_log: "Activity Logs",
    my_remits: "My Remits",
    my_payslips: "My Payslips",
    my_Activity_Log: "Activity Logs",
    ReferFriend: "Refer a Friend",
    MonthlyInvoices: "Manage Invoices",
    Manage_Expanses: "Upload Time / Expense",
    monthly_invoice: "Manage Invoices",
    manage_information: "My Information",
    my_contract: "My Contracts",
    add_users: "Add User",
    add_roles: "Add Roles",
    edit_roles: "Edit Roles",
    activity_log: "Activity Logs",
    company_name: "Company Name",
    registration_number: "Registration Number",
    account_name: "Account Name",
    bank_name: "Bank Name",
    swift_code: "Swift Code",
    intermediary_swift_code: "Intermediary Swift Code",
    account_currency: "Account Currency",
    sort_code: "Sort Code",
    company_name: "Company Name",
    Invoices: "Invoices",
    my_user: "Manage Users",
    add_role: "Add Roles",
    edit_role: "Edit Roles",
    edit_user: "Edit User",
    org_name: "Organization Name",
    module_menu: "Menu/Module",
    create: "Create",
    read: "Read",
    print: "Print/Export",
    please_enter_company_reg_number: "Please enter company registration number",
    preferred_date_format: "Date Format",
    agency_client: "Agency /Client",
    upload_contract: " Upload Signed Contract",
    note: "Notes",
    please_enter_description: "Please enter description",
    description: "Description",
    please_enter_full_account_name: "Please enter account holder name.",
    please_enter_full_bank_name: "Please enter bank name.",
    please_enter_account_number: "Please enter account number.",
    please_enter_full_address: "Please enter address",
    please_enter_full_swift_code: "Please enter swift code",

    manage_countries: "Manage Countries",
    payroll_invoice: "Manage Payroll Partner Invoices ",
    contractor_invoice: "Manage Contractor Invoices ",
    // edit_organization: "Edit Organization"
    routing_number:"Routing Number",
    please_enter_rounting_number:"Please enter routing number",
    please_select_country:"Please select bank country",
    please_select_state:"Please select bank state",
    please_select_currency:"Please select bank currency",
    Company:"Company",
    please_enter_other:"Please enter other",
    address_one:"Address 1",
    address_two:"Address 2",
    banks:"Banks"
};



//////////////////
// WEBPACK FOOTER
// ./lang/en/messages.js
// module id = jejs
// module chunks = 22